import { FC } from 'react';

import clsx from 'clsx';
import { useBreakpoints } from 'hooks';
import { useGetExampleSwitchData } from 'layouts/OnePagePreviewLayout/hooks/useGetExampleSwitchData';
import { useBusinessToolSessionStore } from 'store/useBusinessToolStore';
import { getOnePageDisplayMode } from 'store/useBusinessToolStore/selectors';

import { Button } from 'components/_basic/Button/Button';

import { useOnePageExampleSwitch } from '../../hooks/useOnePageExampleSwitch';

import styles from './OnePageExampleSwitch.module.scss';

export const OnePageExampleSwitch: FC = () => {
  const displayMode = useBusinessToolSessionStore(getOnePageDisplayMode);
  const { isMobile } = useBreakpoints();

  const { icon, label } = useGetExampleSwitchData(displayMode);

  const { changeDisplayModeHandler, isExampleSwitchDisabled } = useOnePageExampleSwitch();

  return (
    <Button
      variant="text"
      size="medium"
      className={clsx(styles['example-switch'], {
        [styles['example-switch--mobile']]: isMobile,
      })}
      startIcon={icon}
      onClick={changeDisplayModeHandler}
      disabled={isExampleSwitchDisabled}
    >
      {!isMobile && label}
    </Button>
  );
};
